// Public surface for the share library.
//
// Components have exactly TWO ways to share:
//   1. `useCopyShareLink({ surface, toast })` — copy a URL to the clipboard
//   2. `<ShareModal trigger url surface ... />` — open a modal where the
//      user picks a platform (X / Telegram / WhatsApp / Reddit / native)
//
// Every share fires an analytics event identifying the surface (where the
// share was initiated). All channel intents, clipboard, native share, and
// toast triggers live inside this folder — no share code anywhere else.
//
// `<ShareModal directChannel='x' />` covers fixed-channel surfaces (e.g.
// gift "Thank on X") without exposing a third API.

export type { ShareAction, ShareSurface, ShareSurfaceInput, ShareSurfaceShorthand } from './events';
export { emitShareEvent } from './events';
export type { BuildProposalBackShareUrlContext } from './proposal-back-url';
export {
  buildProposalBackCanonicalUrl,
  buildProposalBackShareUrl,
} from './proposal-back-url';
export type { CopiedKind, ShareModalProps } from './share-modal';
export { ShareModal } from './share-modal';
export { openShareModal } from './share-modal-imperative';
export type { PlatformChannel } from './share-platforms';
export type { ShareTradeDirectInput } from './share-trade-direct';
export { shareTradeDirect } from './share-trade-direct';
export { buildThesisCanonicalUrl, buildThesisShareUrl } from './thesis-url';
export type { BuildTradeShareUrlContext } from './trade-url';
export { buildTradeCanonicalUrl, buildTradeShareUrl } from './trade-url';
export type {
  CopyShareLinkToast,
  UseCopyShareLinkOptions,
  UseCopyShareLinkResult,
} from './use-copy-share-link';
export { useCopyShareLink } from './use-copy-share-link';
